// extracted by css-extract-rspack-plugin
export default {"cls1":"dossier-cls1_--L","cls2":"dossier-cls2_en7 dossier-cls1_--L"};